import React from 'react';
import {
  Box,
  TextField,
  Button,
  Collapse,
  CircularProgress,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

interface TextEditorProps {
  content: string;
  setContent: (content: string) => void;
  onSubmit: () => void;
  isLoading: boolean;
  showFull: boolean;
}

export const TextEditor: React.FC<TextEditorProps> = ({
  content,
  setContent,
  onSubmit,
  isLoading,
  showFull
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  const textFieldRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (textFieldRef.current && showFull) {
      const textareaElement = textFieldRef.current.querySelector('textarea');
      if (textareaElement) {
        textareaElement.scrollTop = 0;
      }
    }
  }, [content, showFull]);

  return (
    <Collapse in={showFull} collapsedSize={0} timeout={300}>
      <Box>
        <TextField
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Cole aqui o texto do atendimento, relatório ou dados para análise..."
          multiline
          minRows={12}
          maxRows={12}
          fullWidth
          onKeyPress={handleKeyPress}
          variant="outlined"
          ref={textFieldRef}
          sx={{ height: '100%' }}
          InputProps={{
            sx: {
              borderRadius: 2,
              bgcolor: 'white',
              fontSize: 16,
              '&.Mui-focused fieldset': {
                borderColor: 'primary.main',
                borderWidth: 0.5,
              },
            },
          }}
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button
            variant="contained"
            onClick={onSubmit}
            disabled={!content.trim() || isLoading}
            sx={{
              bgcolor: '#00ae9a',
              color: 'white',
              fontWeight: 600,
              borderRadius: 2,
              py: 1,
              px: 3,
              boxShadow: 1,
              '&:hover': {
                bgcolor: '#009688',
                boxShadow: 2,
              },
              transition: 'all 0.2s',
            }}
            endIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          >
            {isLoading ? 'Enviando...' : 'Enviar'}
          </Button>
        </Box>
      </Box>
    </Collapse>
  );
}; 